import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { History, Loader2, RotateCcw } from "lucide-react";

export const NotesHistory = ({ propertyId, open, onClose, onRestore }) => {
  const [list, setList] = useState(null);
  const [pick, setPick] = useState(null);
  useEffect(() => {
    if (!open) return;
    setList(null); setPick(null);
    api.get(`/properties/${propertyId}/notes/versions`).then((r) => { setList(r.data); setPick(r.data[0] || null); }).catch(() => setList([]));
  }, [open, propertyId]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl" data-testid="notes-history-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><History className="h-5 w-5" /> Notes history</DialogTitle></DialogHeader>
        {!list ? <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
          : list.length === 0 ? <p className="py-8 text-center text-sm text-muted-foreground" data-testid="notes-history-empty">No earlier versions yet. A version is kept each time someone new edits, or after 15 minutes.</p> : (
          <div className="grid h-[60vh] gap-3 md:grid-cols-[230px_1fr]">
            <div className="overflow-y-auto border border-border" data-testid="notes-history-list">
              {list.map((v) => (
                <button key={v.id} onClick={() => setPick(v)} data-testid={`notes-version-${v.id}`}
                  className={`block w-full border-b border-border px-3 py-2 text-left text-xs transition-colors ${pick?.id === v.id ? "bg-primary text-primary-foreground" : "hover:bg-secondary"}`}>
                  <div className="font-semibold">{v.saved_at ? new Date(v.saved_at).toLocaleString() : "—"}</div>
                  <div className="opacity-80">{v.saved_by || "—"}</div>
                </button>
              ))}
            </div>
            <div className="flex min-h-0 flex-col gap-2">
              <pre className="flex-1 overflow-auto whitespace-pre-wrap border border-border bg-muted/30 p-3 font-mono text-xs" data-testid="notes-version-content">{pick?.content || "(empty)"}</pre>
              <Button className="self-end" disabled={!pick} onClick={() => { onRestore(pick.content); onClose(); }} data-testid="notes-version-restore">
                <RotateCcw className="mr-2 h-4 w-4" /> Restore this version
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
